import { EntityModel } from '@/interfaces'
import {
  ALL_COLLECTIVE_ADDONS_QUERY,
  CREATE_COLLECTIVE_ADDON_MUTATION,
  DELETE_COLLECTIVE_ADDON_MUTATION,
  FORCE_DELETE_COLLECTIVE_ADDON_MUTATION,
  SINGLE_COLLECTIVE_ADDON_QUERY,
  UPDATE_COLLECTIVE_ADDON_MUTATION,
} from './graphql'
import ratioAgeGroupServiceEntity from '@/entities/ratioAgeGroupService/entity'
import travelPricingServiceCalculationSettingsEntity from '@/entities/travelPricingServiceCalculationSettings/entity'
import travelPricingMandatorySettingsEntity from '@/entities/travelPricingMandatorySettings/entity'

const ratioCollectiveAddonModel: EntityModel = {
  name: 'collectiveAddon',
  namePlural: 'collectiveAddons',
  uniqueName: 'ratioCollectiveAddon',
  uniqueNamePlural: 'ratioCollectiveAddons',
  path: 'travel/pricing/adaptors/ratio/collective_addon',
  baseUrl: '/travel/pricing/adaptors/ratio/collective_addons',
  translationPrefix: 'entities:ratioCollectiveAddon.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_COLLECTIVE_ADDONS_QUERY,
    getSingle: SINGLE_COLLECTIVE_ADDON_QUERY,
    create: CREATE_COLLECTIVE_ADDON_MUTATION,
    update: UPDATE_COLLECTIVE_ADDON_MUTATION,
    delete: DELETE_COLLECTIVE_ADDON_MUTATION,
    forceDelete: FORCE_DELETE_COLLECTIVE_ADDON_MUTATION,
  },
  attributes: {
    label: {
      name: 'label',
      label: 'entities:ratioCollectiveAddon.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioCollectiveAddon.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      maxLength: 255,
      validationType: 'string',
      validations: [],
    },
    ageGroupServices: {
      name: 'ageGroupServices',
      label: 'entities:ratioCollectiveAddon.attributes.ageGroupServices.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioAgeGroupServiceEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    calculationSettings: {
      name: 'calculationSettings',
      label: 'entities:ratioCollectiveAddon.attributes.calculationSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingServiceCalculationSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    mandatorySettings: {
      name: 'mandatorySettings',
      label: 'entities:ratioCollectiveAddon.attributes.mandatorySettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingMandatorySettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioCollectiveAddonModel
